import { useCallback } from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import isEmpty from 'lodash/isEmpty';

import { Dropzone } from '_components/_core';

import { RequiredIndicator } from '../../styles';

const BancoInterFields = ({ values, setFieldValue, touched, errors }) => {
  const handleCertificateCrtChanged = useCallback(
    files => {
      if (isEmpty(files)) {
        return;
      }

      const [certificateFile] = files || [];

      setFieldValue('certificate_crt', certificateFile);
    },
    [setFieldValue],
  );

  const handleCertificateKeyChanged = useCallback(
    files => {
      if (isEmpty(files)) {
        return;
      }

      const [certificateFile] = files || [];

      setFieldValue('certificate_key', certificateFile);
    },
    [setFieldValue],
  );

  return (
    <>
      <Row>
        <Form.Group as={Col} lg="6" className="mb-3">
          <Form.Label>
            Client ID
            <RequiredIndicator>*</RequiredIndicator>
          </Form.Label>
          <Form.Control
            type="text"
            name="client_id"
            value={values.client_id}
            onChange={e => setFieldValue('client_id', e.target.value)}
            isInvalid={touched.client_id && errors.client_id}
            placeholder="Client ID"
          />
          <Form.Control.Feedback type="invalid">{errors.client_id}</Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col} lg="6" className="mb-3">
          <Form.Label>
            Client Secret
            <RequiredIndicator>*</RequiredIndicator>
          </Form.Label>
          <Form.Control
            type="text"
            name="client_secret"
            value={values.client_secret}
            onChange={e => setFieldValue('client_secret', e.target.value)}
            isInvalid={touched.client_secret && errors.client_secret}
            placeholder="Client Secret"
          />
          <Form.Control.Feedback type="invalid">
            {errors.client_secret}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col} lg="6" className="mb-3">
          <Form.Label>
            Certificado .crt <RequiredIndicator>*</RequiredIndicator>
          </Form.Label>
          <Dropzone
            onChange={handleCertificateCrtChanged}
            accept=".crt"
            maxFiles={1}
            readAsBase64
          />

          <Form.Control.Feedback type="invalid">
            {errors.certificate_crt}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col} lg="6" className="mb-3">
          <Form.Label>
            Certificado .key <RequiredIndicator>*</RequiredIndicator>
          </Form.Label>
          <Dropzone
            onChange={handleCertificateKeyChanged}
            accept=".key"
            maxFiles={1}
            readAsBase64
          />
          <Form.Control.Feedback type="invalid">
            {errors.certificate_key}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>
    </>
  );
};

export default BancoInterFields;
